const proxyProfile = '/profile-svc';

export const profileURL =`${proxyProfile}/api/profile-service/v1`;

